import React, { Component, Fragment } from 'react';
import { Modal, Form, Row, Col, Input } from 'antd';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class AddLayerDialog extends Component {
    render() {
        return (
            <Modal
                title="Add Layer"
                visible={this.props.visible}
                onOk={() => {
                    this.form.props.form.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.makoBotStore.addEntryLayer(values);
                            this.props.close();
                        }
                    });
                }}
                onCancel={() => this.props.close()}
            >
                <LayerForm
                    wrappedComponentRef={ref => (this.form = ref)}
                    data={{ price: this.props.price }}
                />
            </Modal>
        );
    }
}

class F extends Component {
    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={12}>
                        <Form.Item label="Price" required={true}>
                            {getFieldDecorator('price', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col md={12}>
                        <Form.Item label="Qty" required={true}>
                            {getFieldDecorator('qty', {
                                initialValue: '10',
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}

export const LayerForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(F);



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/AddLayerDialog.js